import { useState } from 'react';
import { cn } from '@divlab/divanui';

import useTranslation from '@Queries/useTranslation';
import useOnClickOutside from '@Hooks/useOnClickOutside';
import Popup from './elems/Popup/Popup';
import IconBonus from './image/IconBonus';
import styles from './FullСashbackTag.module.css';

import type { FC, HTMLAttributes } from 'react';

interface FullCachbackTagProps extends HTMLAttributes<HTMLDivElement> {
  view?: 'slim' | 'fat';
  isHidePopup?: boolean;
}

const FullСashbackTag: FC<FullCachbackTagProps> = (props) => {
  const { view = 'slim', isHidePopup, className, ...restProps } = props;
  const [visiblePopup, setVisiblePopup] = useState(false);
  const { t } = useTranslation();

  const handleClick = () => {
    if (isHidePopup) return;

    setVisiblePopup((prev) => !prev);
  };

  const refPopup = useOnClickOutside<HTMLDivElement>(() => setVisiblePopup(false));

  return (
    <div
      {...restProps}
      ref={refPopup}
      className={cn(
        styles.main,
        {
          [styles.slim]: view === 'slim',
          [styles.fat]: view === 'fat',
          [styles.hidePopup]: isHidePopup,
        },
        className,
      )}
      onClick={handleClick}
    >
      <IconBonus className={styles.icon} />
      <span className={styles.text}>{t('ui.cashback-tag.tag')}</span>
      {!isHidePopup && <Popup className={styles.popup} visible={visiblePopup} />}
    </div>
  );
};

export default FullСashbackTag;
